import { store } from "@/store.js";

class LogPlugin {
  constructor() {
    this.isLocalhost = this.checkIsLocalhost();
  }

  // Check if running on localhost
  checkIsLocalhost() {
    if (typeof window !== "undefined") {
      return (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.hostname === "0.0.0.0" ||
        window.location.hostname.includes("localhost")
      );
    }
    return false;
  }

  // Main log function
  log(...args) {
    // Check if user is superadmin or running on localhost
    const userData = store.state.userData;
    const isAuthorized =
      (userData && userData.role === "superadmin") || this.isLocalhost;

    if (isAuthorized) {
      // If first item has a Firebase reference path, log it first
      const item = args[0];
      if (item && item.ref && item.ref.path) {
        console.log("📍 Path:", item.ref.path);
      }

      // Log all args
      console.log("🔍 Debug Log:", ...args);
    }
  }
}

// Create log instance
const logger = new LogPlugin();

// Vue plugin definition
const LogVuePlugin = {
  install(Vue) {
    // Add $log to Vue prototype
    Vue.prototype.$log = logger.log.bind(logger);

    // Add global properties
    Vue.$log = logger.log.bind(logger);
  },
};

export default LogVuePlugin;
export { logger };
